import OptionsStore from './OptionsStore';
import Cookies from 'js-cookie';

export class CookieOptionsStore extends OptionsStore {
    options = {
        cookieName: '_cookie-consent',
        attributes: { // https://github.com/js-cookie/js-cookie#cookie-attributes
            expires: 365,
            sameSite: 'Strict',
        },
    };

    constructor(options = {}) {
        super();
        this.options = {...this.options, ...options};
    }

    getData() {
        const data = Cookies.get(this.options.cookieName);
        if (data === undefined) {
            return null;
        }
        return JSON.parse(data);
    }

    // eslint-disable-next-line class-methods-use-this
    setData(data) {
        Cookies.set(this.options.cookieName, JSON.stringify(data), this.options.attributes);
    }

    removeData() {
        Cookies.remove(this.options.cookieName);
    }
}
